import { useContent } from "@/context/ContentContext";

export const PorQue = () => {
  const { por_que: q } = useContent();

  return (
    <section className="sec bn-sec" id="por-que" data-testid="por-que">
      <div className="wrap">
        <p className="lb">{q?.label}</p>
        <h2 className="h h2" style={{ marginTop: 20 }}>
          {q?.title} <span className="ab">{q?.title_accent}</span>
        </h2>
        <p className="lead" style={{ marginTop: 20 }}>{q?.lead}</p>
        <div className="why" style={{ marginTop: "clamp(48px,6vw,88px)" }}>
          {(q?.reasons || []).map((r, i) => (
            <div key={i} data-testid={`por-que-${i}`}>
              <b>{String(i + 1).padStart(2, "0")}</b>
              <h3 className="h h3">{r.t}</h3>
              <p className="p">{r.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
